import { useRouter } from 'next/router';
import React from 'react';

import CTA from '../../components/CTA';
import CustomHead from '../../components/CustomHead';
import Footer from '../../components/FooterNew';
import Header from '../../components/HeaderNew';
import {
  SectionContainer,
  SectionHeading,
} from '../../components/landing/sectionComponents';
import useGa from '../../hooks/useGa';

function BlogFormat() {
  const router = useRouter();

  return (
    <>
      <CustomHead
        meta={{
          title: `PopSQL is part of the GitHub Student Developer Pack`,
        }}
        openGraph={{
          url: `${process.env.NEXT_PUBLIC_WEB_HOST}${router.asPath}`,
        }}
      />
      <main>
        <Header />
        <SectionContainer styles={{ paddingTop: '86px', paddingBottom: '0' }}>
          <SectionHeading
            text={'PopSQL is part of the GitHub Student Developer Pack'}
            moreStyles={{ maxWidth: '800px' }}
          />

          <img
            className="mt-4"
            width="120"
            src={`${process.env.NEXT_PUBLIC_ASSET_HOST}/static/external-logos/github-backpack.png`}
            alt="github backpack logo"
          />

          <div
            style={{ maxWidth: '800px' }}
            className="w-full font-inter text-lg leading-relaxed text-gray-500 mx-auto my-6 md:my-10"
          >
            We've partnered with GitHub Education to offer students enrolled in
            the{' '}
            <a
              href="https://education.github.com/pack"
              target="_blank"
              rel="noreferrer"
            >
              GitHub Student Developer Pack
            </a>{' '}
            our Business plan for free. If you need help with this offer, feel
            free to email{' '}
            <a href="mailto:students@popsql.com">students@popsql.com</a>.
          </div>

          <div className="text-center mb-4">
            <a
              href={`${process.env.NEXT_PUBLIC_WEB_HOST}/users/auth/github_students`}
              onClick={useGa('GitHub Students', 'Hero')}
              className="inline-block bg-primary text-white font-inter font-semibold py-4 px-8 rounded-md hover:shadow-lg focus:shadow-lg focus:outline-none focus:opacity-80 transition duration-200 ease block text-center cursor-pointer leading-none shadow-sm"
            >
              Sign up with GitHub
            </a>
          </div>
        </SectionContainer>

        <CTA />
      </main>
      <Footer />
    </>
  );
}

export default BlogFormat;
